export type Language = 'ru' | 'en';

export const LANGUAGES = {
  ru: { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  en: { code: 'en', name: 'English', flag: '🇺🇸' }
} as const;

export const DEFAULT_LANGUAGE: Language = 'ru';

export const getStoredLanguage = (): Language => {
  if (typeof window === 'undefined') return DEFAULT_LANGUAGE;
  const stored = localStorage.getItem('app-language');
  return (stored && Object.keys(LANGUAGES).includes(stored)) ? stored as Language : DEFAULT_LANGUAGE;
};

export const setStoredLanguage = (language: Language): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem('app-language', language);
  }
};

// Export utilities
export { tr, trDb } from './utils/tr';
export { loadTranslations } from './utils/loader';
export { mergeTranslations } from './utils/merger';

// Export context
export { LanguageProvider, useLanguage } from './context/LanguageContext';

// Export component
export { default as T } from '@/components/T';

// Export component translations
export * from './locales/components';

// Export page translations

// Export page translations  
export { default as integrationsTranslations } from './locales/pages/integrations';
export { default as adminPagesTranslations } from './locales/pages/admin-pages';
export { default as solutionsTranslations } from './locales/pages/solutions';
export { default as platformTranslations } from './locales/pages/platform';
export { default as authTranslations } from './locales/pages/auth';
export { default as bookingsTranslations } from './locales/pages/bookings';
export { default as guestsTranslations } from './locales/pages/guests';
export { default as servicesTranslations } from './locales/pages/services';
export { default as auditTranslations } from './locales/pages/audit';
export { default as settingsTranslations } from './locales/pages/settings';
export { default as dashboardTranslations } from './locales/pages/dashboard';
export { bookingGridTranslations } from './locales/pages/booking-grid/ru';
export { bookingGridTranslations as bookingGridTranslationsEn } from './locales/pages/booking-grid/en';